// extracted by mini-css-extract-plugin
export default {"container":"ListDocumentCard_container__og1CV"};